<template>
  <div class="backup-labels-container">
    <h3 class="backup-labels-title">BACKUP - RESTORE TRACKERS</h3>
    <div>
      Click “Backup Now” to save a copy of the existing trackers in the system.
      Please verify the log that was saved correctly.
    </div>
    <div>
      Click “Restore” when you need to roll back a change with an existing
      backup. Always verify you have selected the right Backup.
    </div>
    <div>Click “Delete” when a backup is not longer needed.</div>
    <b-button
      class="backup-labels-button"
      variant="primary"
      @click="backupNow()"
    >
      Backup now
    </b-button>

    <h4 class="backup-labels-sub-title">EXISTING BACKUPS</h4>

    <b-table :items="backups" :fields="fields" striped>
      <template #cell(backupDate)="data">
        {{ data.item.backupDate | formatDateWithTime }}
      </template>
      <template #cell(actions)="data">
        <b-button
            class="backup-labels-button-outline"
            variant="primary"
            @click="selectBackupToDownload(data.item)"
        >
          Download
        </b-button>
        <b-button
          class="backup-labels-button-outline"
          variant="primary"
          @click="selectBackupToRestore(data.item)"
        >
          Restore
        </b-button>
        <b-button
          class="backup-labels-button-outline"
          variant="primary"
          @click="selectBackupToDelete(data.item)"
        >
          Delete
        </b-button>
      </template>
    </b-table>

    <b-modal
      id="modalInfo"
      v-model="showRestoreModal"
      modal-class="modalInfo"
      title="Restore language Backup"
    >
      <div class="backup-labels-modal-container">
        <p class="backup-labels-danger">
          Danger! You are about to do an action on the system that cannot be
          undone.
        </p>
      </div>
      <div slot="modal-footer" class="backup-labels-modal-footer">
        <b-button @click="showRestoreModal = false"> Close </b-button>
        <b-button
          variant="primary"
          @click="restoreSelectedBackups(selectedBackupToRestore.id)"
        >
          Restore
        </b-button>
      </div>
    </b-modal>

    <b-modal
      id="modalInfo"
      v-model="showDeleteModal"
      modal-class="modalInfo"
      title="Delete tracker Backup"
    >
      <p>Are you sure you want to delete this backup?</p>
      <div slot="modal-footer" class="backup-labels-modal-footer">
        <b-button @click="showDeleteModal = false"> Close </b-button>
        <b-button
          variant="primary"
          @click="deleteBackup(selectedBackupToDelete.id)"
        >
          Delete
        </b-button>
      </div>
    </b-modal>
  </div>
</template>


<script>
import Vue from "vue";
import Icon from "vue-awesome/components/Icon";
import "vue-awesome/icons";
import "@/assets/icons/icons";
import { axiosCall } from "../../../../utils/axiosCall";

Vue.component("Icon", Icon);

export default {
  name: "TrackerBackup",
  data: function () {
    return {
      backups: [],
      fields: ["backupDate", "actions"],
      lastRegeneration: null,
      showRestoreModal: false,
      showDeleteModal: false,
      selectedBackupToRestore: {},
      selectedBackupToDelete: {},
    };
  },
  created: async function () {
    await this.getAllBackups();
  },
  methods: {
   async selectBackupToDownload(item) {
     const response =  await axiosCall({ url: `TrackerBackups/download/${item.id}`, method: "GET",     responseType: "blob", })

     const blob = new Blob([response.data], {
       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
     });

     const url = window.URL.createObjectURL(blob);
     const link = document.createElement("a");
     link.href = url;
     link.download = "trackers.xlsx";
     document.body.appendChild(link);
     link.click();
     link.remove();
     window.URL.revokeObjectURL(url);

    },
    selectBackupToRestore(item) {
      this.selectedBackupToRestore = item;
      this.showRestoreModal = true;
    },
    selectBackupToDelete(item) {
      this.selectedBackupToDelete = item;
      this.showDeleteModal = true;
    },
    backupNow: async function () {
      await axiosCall({ url: "TrackerBackups/CreateBackup", method: "GET" }).then(
        async () => {
          await this.getAllBackups();
        }
      );
    },
    getAllBackups: async function () {
      await axiosCall({
        url: "TrackerBackups/GetAllBackups",
        method: "GET",
      }).then(async (response) => {
        this.backups = response.data;
      });
    },
    restoreSelectedBackups: async function (id) {
      await axiosCall({
        url: `TrackerBackups/RestoreBackup/${id}`,
        method: "GET",
      }).then(() => {
        this.showRestoreModal = false;
        this.selectedBackupToRestore = {};
      });
    },
    deleteBackup: async function (id) {
      await axiosCall({
        url: `TrackerBackups/DeleteBackup/${id}`,
        method: "GET",
      }).then(async () => {
        await this.getAllBackups();
        this.showDeleteModal = false;
        this.selectedBackupToDelete = {};
      });
    },
  },
};
</script>
<style lang="scss">
.backup-labels {
  &-modal {
    &-container {
      padding: 20px;
      text-align: left;
    }
    &-languages {
      text-align: left;
      width: 100px;
      margin: auto;
    }
    &-footer {
      .btn {
        margin-left: 10px;
        border-radius: 5px !important;
      }
    }
  }

  &-container {
    padding: 30px 60px;
  }

  &-button {
    padding: 5px 15px;
    margin-top: 20px;
    margin-bottom: 20px;
    border-radius: 5px !important;
  }

  &-button-outline {
    padding: 5px 15px;
    border-radius: 5px !important;
    margin-right: 15px;
    min-width: 120px;
    background-color: white !important;
    border-width: 2px;
    color: #1e4380 !important;
  }

  &-last-time {
    font-size: 0.8rem;
  }

  &-title {
    margin-bottom: 15px;
  }

  &-sub-title {
    margin-top: 20px;
    margin-bottom: 10px;
  }

  &-danger {
    color: red;
    text-align: left;
  }
}
</style>
